import React from 'react';
import ResetPasswordWithTokenPage from './ResetPasswordWithTokenPage';

const ResetPasswordWithTokenPageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/password/reset',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ResetPasswordWithTokenPage />
				</React.Suspense>
			),
		},
	],
};

export default ResetPasswordWithTokenPageConfig;
